import * as React from "react";
import { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { options } from "laravel-mix";
import axios from "axios";
import { SetupIntentResult } from "@stripe/stripe-js/types/stripe-js/stripe";

interface SetupFormProps {
  card: any;
  onCardDetailsReceived: (cardDetails: any) => void;
}

interface ServerResponse {
  id: number;
  message: string;
  data: object;
}

const SetupForm: React.FC<SetupFormProps> = ({
  card,
  onCardDetailsReceived,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const baseUrl = window.location.protocol + "//" + window.location.hostname;

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return null;
    }

    const { error } = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      redirect: "if_required",
      confirmParams: {
        return_url: baseUrl + "/account/payment-details",
      },
    });

    if (error || error == null) {
      stripe.retrieveSetupIntent(card.setup_intent).then(({ setupIntent }) => {
        //do a call to my api here?
        try {
          const cardDetailsPromise = axios.post<ServerResponse>(
            baseUrl + "/api/cards",
            setupIntent,
          );
          // Use .then() to handle the resolved promise
          cardDetailsPromise
            .then((response) => {
              // Call the callback function with the received data
              onCardDetailsReceived(response.data.data);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } catch (error) {
          console.error("Error:", error);
          // Handle errors here
        }
      });
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button disabled={!stripe}>Submit</button>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

export default SetupForm;
